import Request from 'lib/Request';

import { FindInviteByUuid, SignUpInvite } from './contracts/Invite.contract';

const route = '/invite';

export const findInviteByUuid = (uuid: Invite.Model['uuid']): Promise<FindInviteByUuid.Response> => Request.get([route, uuid, 'public'].join('/'));

export const signUpInvite = (uuid: Invite.Model['uuid'], body: SignUpInvite.Body): Promise<SignUpInvite.Response> => Request.post([route, uuid, 'signup'].join('/'), body);